import JQuery from 'jquery';
import {ValidateRule} from '../validationEditor';
import {HTMLElementWithValidate} from './FormButtonValidate';

export class ValidateTextInput {
  public static frontend(el: HTMLElement) {
    return new this(el);
  }

  public static cleanup(me: ValidateTextInput) {
    me.unhook();
  }

  public $input: JQuery;

  constructor(public el: HTMLElementWithValidate) {
    this.$input = $(el).find('input,textarea,select').eq(0);
    el.meValidate = () => {
      return this.validate();
    };
  }

  public validate(): boolean {
    const $thisEl = $(this.el);
    if ($thisEl.parents('.hide-other').length > 0) return true;
    this.resetErrors();
    const rules = Array.from(
      $thisEl.find('span.error-msg[data-case]').get(),
    ).map((el) => {
      const $el = $(el);
      const rule = $el.attr('data-case');
      let rules = {};
      const ruleString = $el.attr('data-rules');
      if (ruleString === undefined || ruleString === '') {
        return {el, rule, ...rules};
      }
      try {
        rules = JSON.parse(ruleString);
      } catch (e) {
        console.error('Error decode validation rule data', e, ruleString);
      }
      return {el, rule, ...rules};
    });
    for (const rule of rules) {
      if (!this.test(rule as ValidateRule & {el: HTMLElement})) {
        return false;
      }
    }
    return true;
  }

  public resetErrors() {
    $(this.el).find('span.error-msg').hide();
  }

  public test(rule: ValidateRule & {el: HTMLElement}): boolean {
    const value = this.$input.val();
    const type = this.$input.attr('type');
    const invalid = (el, error?: string) => {
      if (error) {
        $(el).text(error);
      }
      $(el).show();
      return false;
    };
    try {
      switch (rule.rule) {
        case 'required':
          if (value.trim().length === 0) {
            return invalid(rule.el);
          }
          if (type === 'checkbox' && !this.$input.prop('checked')) {
            return invalid(rule.el);
          }
          break;
        case 'regex':
          if (!regExpFromRxString(rule.regex).test(value)) {
            return invalid(rule.el);
          }
          break;
        case 'notregex':
          if (regExpFromRxString(rule.regex).test(value)) {
            return invalid(rule.el);
          }
          break;
        case 'jsfunc':
          // tslint:disable-next-line:no-function-constructor-with-string-args
          const fn = new Function('value', '$', rule.fn);
          const result = fn(value, $);
          if (result !== true) {
            return invalid(rule.el, String(result));
          }
          break;
        default:
          console.error('Unknown validation rule', rule);
          break;
      }
      return true;
    } catch (e) {
      console.error(e);
      return invalid(rule.el, `Error Validating Field - ${e}`);
    }
  }

  public unhook() {
    this.el.meValidate = null;
  }
}

const COMMON_ERROR = 'Unable to parse pattern (regex) for validation rule.';
export function regExpFromRxString(regex) {
  if (!regex || regex.length < 2) {
    throw new Error(`${COMMON_ERROR} Regex is too Short`);
  }
  if (regex[0] !== '/') {
    throw new Error(`${COMMON_ERROR} Regex must start with /`);
  }
  const last = regex.lastIndexOf('/');
  if (last - 2 <= 0) {
    throw new Error(`${COMMON_ERROR} Regex is too short`);
  }
  const flags = regex.substr(last + 1);
  const expr = regex.substr(1, last - 1);
  return new RegExp(expr, flags);
}
